<template>
    <div>
        <div class="columns">
            <div class="column is-full">
                <b-button
                type="is-light"
                rounded
                @click="modal=true"
                >
                    <b-icon icon="plus" size="is-small"></b-icon>
                   Agregar nueva variante SKU
                </b-button>
            </div>

            <b-modal :active.sync="modal" scroll="keep">
                <div class="modal-card" style="width:auto">

                    <div class="modal-card-body">
                        <div class="columns is-multiline">
                            <div class="column is-half">
                                <b-field label="Variante">
                                    <b-select
                                    required
                                    expanded
                                    v-model="newSku.variant">
                                        <option v-for="v in variants" :key="v.id" :value="v.id">{{v.getFullTitle}}</option>
                                    </b-select>
                                </b-field>
                            </div>
                            <div class="column is-half">
                                <b-field label="Codigo">
                                    <b-input
                                    v-model="newSku.code">
                                    </b-input>
                                </b-field>
                            </div>
                            <div class="column is-half">
                                <b-field label="Cantidad">
                                    <b-numberinput
                                    type="is-light"
                                    rounded
                                    v-model="newSku.quantity">
                                    </b-numberinput>
                                </b-field>
                            </div>

                            <div class="column is-full has-text-centered">
                                <b-button
                                type="is-primary"
                                rounded
                                @click="createSku"
                                :laoding="btnLoad">
                                    <b-icon icon="save" size="is-small"></b-icon>
                                    Crear nueva variante SKU
                                </b-button>
                            </div>

                        </div>
                    </div>
                </div>
            </b-modal>


        </div>
    </div>
</template>

<script>
import { getHandler, postHandler } from '../../../../services/http'
export default {
    props:{
        skuCreate:{
            type:String,
            default:""
        },
        variants:{
            type:Array,
            default:new Array([])
        },
    },
    data(){
        return{
            modal:false,
            newSku:{},
            btnLoad:false
        }
    },
    methods:{
        async createSku(){
            this.btnLoad=true
            var msg = {resource:"notify"}
            if (this.newSku.variant){
                let res = await postHandler(this.skuCreate, this.newSku, {error:msg, success:msg})
                this.btnLoad=false
                this.$emit("done")
                this.newSku={}
            }
        }
    }
}
</script>